
<!-- <app-sidebar *ngIf="isUserLogin()"> </app-sidebar> -->
@if (isUserLogin()) {
  <app-sidebar-1></app-sidebar-1 >
}
<app-mobile-display></app-mobile-display>
<router-outlet >
</router-outlet>
